import ApiService from "@/common/api/api.service";
import Detalhes from "./accordion/Detalhes";
import Rubricas from "./accordion/Rubricas";
import RH from "./accordion/RH";
import Empresas from "./accordion/Empresas";
import CronogramaEtapa from "./accordion/CronogramaEtapa";
import Atividades from "./accordion/Atividades";
import Aneel from "./accordion/Aneel";
import Investimentos from "./accordion/Investimentos";
import ContratoDocumentacao from "./accordion/ContratoDocumentacao";
import Resultados from "./accordion/Resultados";
import ComprovanteHH from "./accordion/ComprovanteHH";

let endpoint = "ProjetoGestao";


const ProjetoGestaoService = {

    setEndpoint: function(endpointSelecionado){
        endpoint = endpointSelecionado;
        let accordion = [Investimentos];
        accordion.forEach(function(item){
            item.setEndpoint(endpoint);
        });
    },

    listarProjetos: function(empresaId, texto = "", tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`${endpoint}?EmpresaId=${empresaId}&texto=${texto}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscarProjetoGestao: function(id){
        return ApiService.get(`${endpoint}/${id}`);
    },

    salvarDetalhes : Detalhes.salvar,
    
    buscarDespesa : Rubricas.buscar,
    salvarDespesa : Rubricas.salvar,
    excluirDespesa : Rubricas.excluir,
    downloadArquivoDespesa : Rubricas.downloadArquivo,
    
    //RH
    adicionarRH: RH.adicionar,
    listarRH: RH.listar,
    salvarRH: RH.salvar,
    deletarRH : RH.deletar,

    listarEmpresa: Empresas.listar,
    salvarEmpresa : Empresas.salvar, 
    listarEmpresasModal : Empresas.listarModal,
    removerEmpresa : Empresas.removerEmpresa,

    listarCronograma : CronogramaEtapa.listarCronograma,
    salvarCronograma : CronogramaEtapa.salvarCronograma,

    salvarEtapa : CronogramaEtapa.salvarEtapa,
    salvarSubetapa : CronogramaEtapa.salvarSubetapa,
    salvarRelatorio : CronogramaEtapa.salvarRelatorio,
    removerRelatorio : CronogramaEtapa.removerRelatorio,
    removerSubetapa : CronogramaEtapa.removerSubetapa,
    salvarDetalhamento : CronogramaEtapa.salvarDetalhamento,
    excluirCronograma : CronogramaEtapa.excluirCronograma,    
    uploadRelatorio : CronogramaEtapa.uploadRelatorio,
    aprovarRelatorio : CronogramaEtapa.aprovarRelatorio,

    buscarAtividade : Atividades.buscarAtividade,
    salvarAtividade : Atividades.salvarAtividade,

    salvarXML: Aneel.salvar,
    listarXML: Aneel.listar,
    buscarXML: Aneel.buscar,
    deletarXML: Aneel.deletar,
    downloadXML: Aneel.download,
    
    buscarInvestimentos : Investimentos.buscarInvestimentos,
    salvarInvestimento : Investimentos.salvarInvestimento,

    salvarContratoDocumentacao : ContratoDocumentacao.salvarContratoDocumentacao,
    listarContratoDocumentacao : ContratoDocumentacao.listarContratoDocumentacao,
    excluirContratoDocumentacao : ContratoDocumentacao.excluirContratoDocumentacao,

    salvarResultados: Resultados.salvar,
    atualizarResultados: Resultados.atualizar,
    listarResultados: Resultados.listar,
    buscarResultados: Resultados.buscar,
    deletarResultados: Resultados.deletar,
    downloadArquivoResultados: Resultados.downloadArquivo,

    baixarAnexo5(id, consolidado = false){
        return ApiService.get(`${endpoint}/anexo5?id=${id}&consolidado=${consolidado}`);
    },

    baixarHH(id, idRH, data) {
        return ApiService.downloadFile(`${endpoint}/declaracao-hh?id=${id}&pessoaId=${idRH}${data ? `&data=${data}` : ''}`);
    },

    apagar(id) {
        return ApiService.delete(`ProjetoGestao?id=${id}`);
    },

    //ComprovanteHH
    salvarComprovanteHH: ComprovanteHH.salvar,
    listarComprovanteHH: ComprovanteHH.listar,
    buscarComprovanteHH: ComprovanteHH.buscar,
    deletarComprovanteHH: ComprovanteHH.deletar,
    downloadComprovanteHH: ComprovanteHH.downloadComprovanteHH,

    baixarComprovantes(id, incluirPagadora) {
        return ApiService.downloadFile(`${endpoint}/comprovantes?id=${id}&projetoId=${id}&IncluirComprovantesEmQueSouPagadora=${incluirPagadora}`);
    },
    baixarComprovanteRubricas(id, rubrica) {
        return ApiService.downloadFile(`${endpoint}/comprovantes-${rubrica}?projetoId=${id}`);
    },
};

export default ProjetoGestaoService;
